import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import { PureButton, PureLink } from '../../basics';
import { RenderType } from '../../enums';
import { LinkContent } from './LinkContent';
import { useLinkClassName } from './useLinkClassName';
const Link = forwardRef(({ as, children, className, dataTestId, disabled = false, iconLeft, iconRight, internal, onClick, variant, ...restLinkProps }, elementRef) => {
    const linkClassName = useLinkClassName({
        variant,
        hasIcon: Boolean(iconLeft || iconRight),
    });
    const onClickHandler = disabled ? () => null : onClick;
    if (as === RenderType.Button) {
        return (_jsx(PureButton, { "data-testid": dataTestId, className: classNames(className, linkClassName), ref: elementRef, disabled: disabled, onClick: onClickHandler, ...restLinkProps, children: _jsx(LinkContent, { iconLeft: iconLeft, iconRight: iconRight, children: children }) }));
    }
    return (_jsx(PureLink, { "data-testid": dataTestId, className: classNames(className, linkClassName), ref: elementRef, internal: internal, useDefaultStyle: false, disabled: disabled, onClick: onClick, ...restLinkProps, children: _jsx(LinkContent, { iconLeft: iconLeft, iconRight: iconRight, children: children }) }));
});
Link.displayName = Link.name;
export { Link };
